import { useCallback, useMemo, useState } from "react";

const useMixMatchValidation = (configData, categoryOption) => {
  const [formErrors, setFormErrors] = useState([]);

  const lookupId = useMemo(() => {
    return categoryOption?.find(
      (item) =>
        item.value?.toLowerCase() === configData.categoryName?.toLowerCase()
    )?.id;
  }, [categoryOption, configData.categoryName]);

  const hasInterviewType = configData.interviewTypeOption?.length > 0;

  const isCreateDisabled = useMemo(() => {
    if (
      !configData.interviewName?.trim() ||
      !configData.categoryName?.trim() ||
      !lookupId ||
      !configData.difficulty?.trim() ||
      !configData.industryType ||
      !configData.interviewRole ||
      !configData.rubric_url?.trim() ||
      (hasInterviewType && !configData.interviewType)
    ) {
      return true;
    }

     if (!hasInterviewType) return true;
     if (!configData.interviewType) return true;
    const duration = Number(configData.duration);
    return (
      Number.isNaN(duration) || duration < 5 || duration > 120
    );
  }, [
    configData.categoryName,
    configData.difficulty,
    configData.duration,
    configData.interviewName,
    configData.industryType,
    configData.interviewRole,
    configData.rubric_url,
    configData.interviewType,           
    configData.interviewTypeOption, 
    lookupId,
  ]);

  const validateForm = useCallback(() => {
    const validationRules = [
      {
        condition: !configData.interviewName?.trim(),
        message: "Interview name is required.",
      },
      {
        condition: !configData.categoryName?.trim(),
        message: "Category selection is required.",
      },
      {
        condition: !lookupId,
        message: "Selected category is invalid.",
      },
      {
        condition: !configData.difficulty?.trim(),
        message: "Difficulty level is required.",
      },
      {
        condition:
      !configData.duration ||
      Number.isNaN(Number(configData.duration)) ||
      Number(configData.duration) < 5 ||
          Number(configData.duration) > 120,
        message: "Duration must be between 5 and 120 minutes.",
      },
      {
        condition: !configData.industryType,
        message: "Industry Type is required.",
      },
      {
        condition: !configData.interviewRole,
        message: "Interviewer Role is required.",
      },
      {
        condition: !configData.rubric_url?.trim(),
        message: "Rubric file (.xlsx) is required.",
      },
      {
        condition:
          configData.interviewTypeOption?.length > 0 &&
          !configData.interviewType,
        message: "Interview Type is required.",
      },
    ];

    const errors = validationRules
      .filter((rule) => rule.condition)
      .map((rule) => rule.message);

    setFormErrors(errors);
    return errors.length === 0;
  }, [
    configData.categoryName,
    configData.difficulty,
    configData.duration,
    configData.interviewName,
    configData.industryType,
    configData.interviewRole,
    configData.rubric_url,
    lookupId,
  ]);

  return {
    formErrors,
    isCreateDisabled,
    lookupId,
    setFormErrors,
    validateForm,
  };
};

export default useMixMatchValidation;

